<ul class="inspiration-items">
  <li *ngFor="let handle of handles" [class.active]="current.storage.handlesId === handle.id">
    <figure (click)="selectHandles(handle.id)">
      <span class="media">
        <img *ngIf="handle.img !== ''" [src]="'assets/img/' + handle.img" [alt]="handle.label" />
        <span class="title-overlay">
   {{ handle.label | translate }}
  </span>
        <span class="state">
          <svg class="icon-action-select-thumb" aria-hidden="true">
            <use
              xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="assets/img/icons.svg#icon-action-select-thumb"></use>
          </svg>
        </span>
      </span>
    </figure>
  </li>
</ul>
